<template>
  <div>
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content"
           v-loading="loadingStaus"
           :element-loading-text="loadingText">
        <el-row :gutter="48">

          <el-form ref="companyForm" :model="formData" :rules="rules" label-width="150px">
            <el-col :span="18">
              <h2>申请信息</h2>
              <el-form-item label="姓名" prop="realname">
                <el-input disabled v-model="formData.realname"></el-input>
              </el-form-item>
              <el-form-item label="身份证地址" prop="address">
                <el-input disabled type="input" v-model="formData.address"></el-input>
              </el-form-item>
              <el-form-item label="手机号码" prop="mobile">
                <el-input disabled type="input" v-model="formData.mobile"></el-input>
              </el-form-item>
              <el-form-item label="身份证号" prop="idcard">
                <el-input disabled type="input" v-model="formData.idcard"></el-input>
              </el-form-item>
              <el-form-item label="规格" prop="specs">
                <el-input disabled type="input" v-model="formData.specs"></el-input>
              </el-form-item>
              <el-form-item label="类目" prop="category_name">
                <el-input disabled type="input" v-model="formData.category_name"></el-input>
              </el-form-item>
              <el-form-item label="单位" prop="unit">
                <el-input disabled type="input" v-model="formData.unit"></el-input>
              </el-form-item>
              <el-form-item label="数量" prop="number">
                <el-input disabled type="input" v-model="formData.number"></el-input>
              </el-form-item>
              <el-form-item label="额度" prop="money">
                <el-input disabled type="input" v-model="formData.money"></el-input>
              </el-form-item>

              <h2>开票公司信息</h2>
              <el-form-item label="公司名称" prop="category_name">
                <el-input disabled type="input" v-model="formData.category_name"></el-input>
              </el-form-item>
              <el-form-item label="税号" prop="taxpayer">
                <el-input disabled type="input" v-model="formData.taxpayer"></el-input>
              </el-form-item>
              <el-form-item label="公司地址" prop="company_address">
                <el-input disabled type="input" v-model="formData.company_address"></el-input>
              </el-form-item>
              <el-form-item label="开户行" prop="bank">
                <el-input disabled type="input" v-model="formData.bank"></el-input>
              </el-form-item>
              <el-form-item label="银行卡" prop="bank_card">
                <el-input disabled type="input" v-model="formData.bank_card"></el-input>
              </el-form-item>
              <el-form-item label="手机号码" prop="company_mobile">
                <el-input disabled type="input" v-model="formData.company_mobile"></el-input>
              </el-form-item>

              <h2>合同</h2>
              <el-form-item label="合同" prop="express_img" v-if="formData.contract_urls.length>0">
                <img :key="index" v-for="(item,index) in formData.contract_urls" class="expressImg" :src="item" @click="showImage(item)"/>
              </el-form-item>

              <h2>转账凭证</h2>
              <el-form-item label="转账凭证" prop="express_img" v-if="formData.evidence_urls.length>0">
                <img :key="index" v-for="(item,index) in formData.evidence_urls" class="expressImg" :src="item" @click="showImage(item)"/>
              </el-form-item>

              <h2>发票实拍</h2>
              <el-form-item label="发票图片" prop="express_img" v-if="formData.express_img">
                <img class="expressImg" :src="formData.express_img" @click="showImage(formData.express_img)"/>
              </el-form-item>

              <h2>实名认证</h2>
              <el-form-item label="实名认证" prop="express_img" v-if="formData.face_url">
                <img class="expressImg" :src="formData.face_url" @click="showImage(formData.face_url)"/>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
        <!-- 预览图片弹框 -->
        <el-dialog
          :title="'预览图片'"
          :visible.sync="dialogVisible"
          :modal="false"
          :width="'50%'"
        >
          <div class="block" v-if="dialogVisible">
            <img :src="this.imageUrl" class="preview">
          </div>
        </el-dialog>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import UploadFile from "@/components/UploadFile";
import {mapGetters} from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    UploadFile,
  },
  data() {
    return {
      id: '',
      dialogVisible: false,
      activeTab: '0',
      hearTitle: '基本设置',
      loadingStaus: true,
      loadingText: '正在提交中……',
      formDisabled: false,
      billId: 0, // 公司id，0表示创建，非零为编辑
      // element的cascader的props值
      cascaderProps: {
        label: 'display_name',
        value: 'id',
      },
      // 分类列表
      categoryList: [],
      openapiList: [],
      // 标签
      categoryLabelList: [],
      // 已选中的分类列表，用于cascader组件选中效果
      selectedList: [],
      // 已选中标签
      selectedLabelList: [],
      // 公司基本信息表单结构
      formData: {
        file_url: '',
        status: 0
      },
      // 已上传图片列表
      uploadFileList: [],
      // 公司基本信息规则
      rules: {
        name: [
          {required: true, message: '输入公司名称', trigger: 'blur'},
        ],
        file_url: [
          {required: true, message: '输入文件名称', trigger: 'blur'},
        ]
      },
      // 附件类型
      attachmentType: ['application/pdf', 'application/caj', '', 'application/zip', 'application/rar', 'application/doc'],
      // 已上传附件列表
      attachmentUploadFileList: [],
      imageUrl: '',//图片地址
    }
  },
  computed: {
    ...mapGetters(['userPermissions']),
  },
  methods: {
    /* 预览图片 */
    showImage(data) {
      this.dialogVisible = true;
      this.imageUrl = data;
    },
    // 删除文件回调
    handleRemoveFile() {
      console.log("->删除成功....");
    },
    // 上传文件成功回调
    handUploadFile({url, filename}) {
      console.log("->上传成功....", url, filename);
      this.formData.file_url = url
      console.log("formData", this.formData)
    },
    // 返回列表
    returnList() {
      this.$router.push('/bill')
    },
    // 菜单选择
    categoryChange(v) {
      console.log("categoryChange", v)
      if (v) {
        this.formData.parent_id = v
      }
    },
    openapiChange(v) {
      console.log("openapiChange", v)
      if (v) {
        this.formData.openapi_id = v
      }
    },
    // 级联菜单组件change事件
    cascaderLabelChange(v) {
      if (v.length) {
        this.formData.category_2_id = v[(v.length - 1)]
        this.formData.category_2_ids = v
      } else {
        this.formData.category_2_id = ''
        this.formData.category_2_ids = []
      }
    },
    // 级联菜单自定义验证，选择分类
    cascaderVerify(rule, value, callback) {
      if (rule.required && !this.selectedList.length) {
        callback(new Error(rule.message))
      }
      callback()
    },
    // 确认保存按钮
    async saveConfirm() {
      // 调用组件的数据验证方法
      this.$refs['companyForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
      return true
    },
    // 公司相关信息的保存处理
    async formSubmit() {
      // this.loadingStaus = true
      // console.log("formData -> ", this.formData);
      // try {
      //   let id = await this.$api.saveBill(this.formData)
      //   if (id.length > 0) {
      //     this.$notify.success('保存成功！')
      //     if (this.billId === 0 && id) {
      //       this.$router.push(this.$route.matched[1].path)
      //     }
      //   }
      //   this.$nextTick(() => {
      //     this.loadingStaus = false
      //   })
      // } catch(err) {
      //   console.log('err is ->', err)
      // }
    },
    // 图片上传成功回调
    handleUploadSuccess(file, fileList) {
      this.formData.cover = file.id
      this.uploadFileList = fileList
    },
    // 图片删除回调
    handleUploadRemove(file, fileList) {
      this.formData.cover = 0
      this.uploadFileList = fileList
    },
    // 附件上传成功回调
    handleAttachmentUploadSuccess(file, fileList) {
      this.formData.attachment = file.id
      this.attachmentUploadFileList = fileList
    },
    // 附件删除回调
    handleAttachmentUploadRemove(file, fileList) {
      this.formData.attachment = 0
      this.attachmentUploadFileList = fileList
    },
    // 图片上传自定义验证
    apeUploaderVerify(rule, value, callback) {
      if (rule.required && !this.formData.cover) {
        callback(new Error(rule.message))
      }
      callback()
    },
    // 处理编辑器内容输入
    handleTinymceInput(val) {
      this.formData.content = val
    },
    // 初始化公司基本信息
    async init() {
      let url = this.$route.path
      let urlSlashCount = url.split('/').length
      this.action = url.split('/')[urlSlashCount - 1].toLowerCase()
      this.formDisabled = (this.action === 'view') ? true : false
      if (this.$route.params.invoicing_id) {
        this.id = this.$route.params.invoicing_id
      }
      if (this.id) {
        let args = {}
        let info = await this.$api.getInvoiceInfo(args, this.id)
        this.formData = info
        console.log(this.formData,'表单数据')
      }
    },
    //返回上一页
    goBack() {
      this.$router.push({path: "/individual"});
    }
  },
  async mounted() {
    this.loadingStaus = true
    this.init()
    this.$nextTick(() => {
      this.loadingStaus = false
    })
  },
}
</script>

<style lang="stylus" scoped>
.content-left
  min-height 640px
  border-right 1px solid #e8e8e8

  .el-cascader
    display block
    width 320px

.back-btn
  position absolute;
  right 50px;
  top 150px;

.content-right
  .right-button
    border-top 1px solid #e8e8e8e8
    padding 12px 12px

  .el-form-item__label
    float none
    display inline-block
    text-align left
    padding 0 0 10px 0

  .el-form-item__content
    margin-left 0px !important

    .el-checkbox-group
      margin-top -12px

.preview
  width: 100%

.idImg
  width: 100px
  cursor: pointer

.expressImg
  width:300px
  height:auto
</style>
